import { useEffect, useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ DetailwarehouseData }) => {

    console.log(DetailwarehouseData, "DetailwarehouseData");
    const [warehouseid,setWarehouseId] = useState('')
    useEffect(()=>{
        if (DetailwarehouseData) {
            setWarehouseId(DetailwarehouseData.name)
        }
    },[DetailwarehouseData])

        console.log(warehouseid,"warehouseid");
        
    const accountOptions = [
        { name: 'Test Account 1' },
        { name: 'Test Account 2' },
        { name: 'Test Account 3' },
    ];

    return (
       <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                      <label style={{height: '19px'}}></label>
                  <Checkbox
              id="Is_Group_Warehouse"
              label="Is Group Warehouse"
              value={!!DetailwarehouseData?.is_group}
              checked={true}
              disabled={true}
            />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Warehouse Name"
                                label="Warehouse Name"
                                style={{ height: "30px" }}
                                readOnly={true}
                                value={DetailwarehouseData?.warehouse_name || ''}
                            />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Company"
                                label="Company"
                                style={{ height: "30px" }}
                                readOnly={true}
                                value={DetailwarehouseData?.company || ''}
                            />
                                 
                                </div>
                            </div>
                             <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                     <Input
                                id="ParentWarehouse"
                                label="Parent Warehouse"
                                style={{ height: "30px" }}
                                readOnly={true}
                                value={DetailwarehouseData?.parent_warehouse || ''} 
                            />
                  

                            
                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input
                                id="Account"
                                label="Account"
                                style={{ height: "30px" }}
                                readOnly={true}
                                value={DetailwarehouseData?.account || ''} 
                            />
                                    
                                </div>
                                <div style={{ flex: 1 }}>
                                   <Input
                                id="Abbr"
                                label="Abbr"
                                style={{ height: "30px" }}
                                 value={DetailwarehouseData?.abbr || ''}
                                 readOnly
                            />
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Warehouse Contact Info</p>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Phone No."
                                label="Phone No."
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.phone_no || ''}
                                readOnly
                            />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Mobile No."
                                label="Mobile No."
                                style={{ height: "30px" }}
                               value={DetailwarehouseData?.mobile_no || ''}
                               readOnly
                            />

                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input
                                id="Address Line 1"
                                label="Address Line 1"
                                style={{ height: "30px" }}
                                value={DetailwarehouseData?.address_line_1 || ''}
                                readOnly
                            />
                                </div>
                            </div>

                              <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                   <Input
                                id="Address Line 2"
                                label="Address Line 2"
                                style={{ height: "30px" }}
                                 value={DetailwarehouseData?.address_line_2 || ''}
                                 readOnly
                            />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                id="County"
                                label="County"
                                style={{ height: "30px" }}
                                 value={DetailwarehouseData?.county || ''}
                                 readOnly
                            />

                                </div>
                                <div style={{ flex: 1 }}>
                                     <Input
                                id="State/Province"
                                label="State/Province"
                                style={{ height: "30px" }}
                                 value={DetailwarehouseData?.state || ''}
                                 readOnly
                            />
                                </div>
                            </div>
 <div style={{ display: 'flex', gap: '15px' }}>


                                <div style={{ flex: 1 }}>
                                  <Input
                                id="City/Town"
                                label="City/Town"
                                style={{ height: "30px" }}
                               value={DetailwarehouseData?.city || ''}
                               readOnly
                            />
                                </div>

                                <div style={{ flex: 1 }}>
                                    <Input
                                id="Postal Code"
                                label="Postal Code"
                                style={{ height: "30px" }}
                                 value={DetailwarehouseData?.pin || ''}
                                 readOnly
                            />

                                </div>
                                <div style={{ flex: 1 }}>
                                     
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                  <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

            <div className="col-md-12 px-2">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


                <ActivityCard doctype="Warehouse" docname={warehouseid} />





              </div>
            </div>

          </div>
            </div>

        </div>
    );
};

export default Tab1;